const base = ""
export const estateDetailsPage = (estateId, pois) => `${base}/estates/${estateId}/details${pois ? '?pois='+ pois : ''}`
//export const estatePhoto =       (photoUrl) => `http://demo.ouhabiter.ca/photos/${photoUrl}`
export const estatePhoto =       (photoUrl) => `/photos/${photoUrl}`

export const estateSummaries =         _ => `${base}/api/estates/summary`
export const executeListQuery =        _ => `${base}/api/estates/listSearch`
export const executeMapQuery =         _ => `${base}/api/estates/mapSearch`
export const estateDetails =  (estateId) => `${base}/api/estates/${estateId}`

export const controltables =    ({lang})   => `${base}/api/controlTables?lang=${lang}`
export const fetchDirections =  estateId   => `${base}/api/estates/${estateId}/direction`
export const getAddress =                _ => `${base}/api/geocoding/coordinates`
export const getAddressFromCoordinates = _ => `${base}/api/geocoding/address`
export const getSuggestions =            _ => `${base}/api/amenities/suggested`
export const getLocations =              _ => `${base}/api/locations`
export const fetchServices =             _ => `${base}/api/services`

export const checkToken = (userName, token) => `${base}/api/users/${userName}/token/${token}`

export const likeEstate = (userName, estateId) => `${base}/api/users/${userName}/likes/${estateId}`
export const fetchLikes = (userName) => `${base}/api/users/${userName}/likes`

export const saveQuery =  (userName) => `${base}/api/users/${userName}/queries`
export const fetchQueries = (userName) => `${base}/api/users/${userName}/queries`
export const fetchQuery = (userName, queryId) => `${base}/api/users/${userName}/queries/${queryId}`
export const deleteQuery = (userName, queryId) => `${base}/api/users/${userName}/queries/${queryId}`

export const individualEstateRegister = (lang) => `${base}/estates/individual?lang=${lang}`
export const batchEstatesRegister = (lang) => `${base}/estates/batch?lang=${lang}`
export const profile = (userName, lang) => `${base}/users/${userName}/profile?lang=${lang}`
export const login = (lang, redirect) => `${base}/login?lang=${lang}&redirect=${redirect}`
export const logout = (lang) => `${base}/logout?lang=${lang}`



/** WEBPACK FOOTER **
 ** ./app/conf/production.js
 **/